import { useEffect, useState } from 'react';
import { fetchJsonAsset } from '../utils';
import type { CallToActions, MediaProjectInstanceResponse } from '../types';

/**
 * Client-side loader for a publication's CallToActions asset (the JSON
 * file referenced by the `assets` entry with `asset_type === 'CallToActions'`
 * — same lookup `useLoadAssets` uses for the classic experience). Admin has
 * the full publication in hand but only the asset URL, so it fetches the
 * JSON itself; sales resolves the equivalent server-side in getExperienceData.
 */
export const useCallToActions = (
  publication?: MediaProjectInstanceResponse | null,
): CallToActions | undefined => {
  const [callToActions, setCallToActions] = useState<
    CallToActions | undefined
  >();

  const ctasAssetPath = Object.values(publication?.assets ?? {}).find(
    (asset) => asset.asset_type === 'CallToActions',
  )?.path;

  useEffect(() => {
    if (!ctasAssetPath) return;
    let cancelled = false;

    fetchJsonAsset<CallToActions>(ctasAssetPath).then((asset) => {
      if (!cancelled) setCallToActions(asset ?? undefined);
    });

    return () => {
      cancelled = true;
    };
  }, [ctasAssetPath]);

  return callToActions;
};
